/**
 * Currency utilities for Voluum reports.
 * Voluum uses ISO 4217 3-letter codes. For Media Devoted | Created By Ciro Autiero
 */

import { SUPPORTED_CURRENCIES } from '@/lib/currencies';

/** countryKey (lowercase, normalized) -> ISO 4217 currency code */
const CURRENCY_BY_COUNTRY: Record<string, string> = {
  australia: 'AUD',
  au: 'AUD',
  austria: 'EUR',
  belgium: 'EUR',
  be: 'EUR',
  brazil: 'BRL',
  br: 'BRL',
  canada: 'CAD',
  ca: 'CAD',
  colombia: 'COP',
  co: 'COP',
  croatia: 'EUR',
  hr: 'EUR',
  czech_republic: 'CZK',
  czech: 'CZK',
  cz: 'CZK',
  finland: 'EUR',
  fi: 'EUR',
  france: 'EUR',
  fr: 'EUR',
  germany: 'EUR',
  de: 'EUR',
  greece: 'EUR',
  gr: 'EUR',
  hungary: 'HUF',
  hu: 'HUF',
  italy: 'EUR',
  it: 'EUR',
  mexico: 'MXN',
  mx: 'MXN',
  netherlands: 'EUR',
  nl: 'EUR',
  new_zealand: 'NZD',
  newzealand: 'NZD',
  nz: 'NZD',
  norway: 'NOK',
  no: 'NOK',
  poland: 'PLN',
  pl: 'PLN',
  portugal: 'EUR',
  pt: 'EUR',
  romania: 'RON',
  ro: 'RON',
  singapore: 'SGD',
  sg: 'SGD',
  spain: 'EUR',
  es: 'EUR',
  sweden: 'SEK',
  se: 'SEK',
  switzerland: 'CHF',
  ch: 'CHF',
  turkey: 'TRY',
  tr: 'TRY',
  uk: 'GBP',
  united_kingdom: 'GBP',
  gb: 'GBP',
};

/** Default currency when country unknown */
export const DEFAULT_CURRENCY = 'USD';

export function getCurrencyForCountry(countryKey: string | null | undefined): string {
  if (!countryKey || typeof countryKey !== 'string') return DEFAULT_CURRENCY;
  const key = countryKey.toLowerCase().trim().replace(/\s+/g, '_').replace(/-/g, '_');
  return CURRENCY_BY_COUNTRY[key] ?? DEFAULT_CURRENCY;
}

/**
 * Voluum-supported currencies (ISO 4217 3-letter codes).
 * Used for the report currency param and display. Sourced from the shared
 * SUPPORTED_CURRENCIES list so the report filter and network-rule form stay in
 * sync.
 */
export const VOLUUM_CURRENCIES = SUPPORTED_CURRENCIES;

/** Normalize to 3-letter uppercase ISO 4217 (e.g. "usd" -> "USD") */
export function normalizeCurrencyCode(raw: string | null | undefined): string {
  if (!raw || typeof raw !== 'string') return DEFAULT_CURRENCY;
  const trimmed = raw.trim().toUpperCase();
  if (trimmed.length === 3) return trimmed;
  return DEFAULT_CURRENCY;
}
